import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  StoreCatalogPage,
  storeProductListParams,
  storeProductListQueryOptions,
  storeProductListSearchSchema,
} from '@/features/store-catalog';

export const Route = createFileRoute('/_authed/_active/s/$storeId/catalog/')({
  staticData: { tours: ['store-catalog.list'] },
  // Typed as the raw input so links into the list need no search.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    storeProductListSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'products.read');
  },
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...storeProductListQueryOptions(params.storeId, storeProductListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // A filter, sort or page change on the list itself must not wait for the fetch, or a second
    // pick in the filter picker would build on stale filters (see the orders route).
    if (cause !== 'stay') await prefetch;
  },
  component: StoreCatalogPage,
});
